import React, { useRef, useEffect, useState } from 'react';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import useTranslate from '~hooks/useTranslate/useTranslate';
import Link from 'gatsby-core-theme/src/hooks/link';
import PopupCard from 'gatsby-matrix-theme/src/components/atoms/cards/popup-card';
import { setIdleTimeout } from 'gatsby-matrix-theme/src/helpers/popup';
import { isMobileDevice } from 'gatsby-core-theme/src/helpers/device-detect';
import months from 'gatsby-matrix-theme/src/constants/months';

import styles from 'gatsby-matrix-theme/src/components/organisms/popup/popup.module.scss';

const Popup = ({
  module,
  isStorybook = false,
  toggle = true,
  icon = null,
  numberOfItems = 4,
  link = 'casino-bonuses',
  template,
  operatorStatus,
}) => {
  const modal = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isIdle, setIsIdle] = useState(false);

  //(showedPopup) this variable I used to handle if I showed a popup in the not_recommended operators,
  // if yes this variable will be true and not will show a popup again until we don't refresh the page
  let showedPopup = false;
  const { items } = module.items[0];
  const shownItems = items?.slice(0, numberOfItems) || [];
  const { style } = module;
  const tracker = isMobileDevice() ? 'mobpopup' : 'popup';
  const date = new Date();
  const month = months[date.getMonth()];
  const title = useTranslate('popup_title', 'Claim These Exclusive Bonuses').replace(
    'month',
    month
  );

  const toggleTitle = useTranslate('popup_toggle_title', 'Claim These Exclusive Bonuses').replace(
    'month',
    month
  );

  const handelActive = (status) => {
    setShowModal(status);
  };

  const idleTimeout = () => {
    setIsIdle(true);
  };

  const displayModal = () => {
    const popupExists = sessionStorage.getItem('popstate');
    if (!popupExists) {
      setShowModal(true);
      sessionStorage.setItem('popstate', true);
    }
    // first we check if session storage is true, if we don't check it the popup will show up twice
    // after we show the popup in the not_recommended operator, this showedPopup will be true and we don't show po[up till user refresh the site
    else if (popupExists && operatorStatus === 'not_recommended' && !showedPopup) {
      setShowModal(true);
      showedPopup = true;
    }
  };

  const handleEsc = (event) => {
    if (event.keyCode === 27) {
      setShowModal(false);
    }
  };

  const handleOutsideClick = (event) => {
    if (modal.current && modal?.current === event.target) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (isIdle) {
      window.addEventListener('scroll', displayModal);
    }
  }, [isIdle]);

  // useEffect(() => {
  //   if (showModal) {
  //     modal.current.classList.toggle(styles.activeModal);
  //   } else {
  //     modal.current.classList.remove(styles.activeModal);
  //   }
  // }, [showModal]);

  // Close on esc
  // Close on outside click
  // Show Popup on Idle and on window leave
  useEffect(() => {
    const time = process.env.EXPIRE_SECONDS_POPUP;
    const expireSeconds = typeof time !== 'undefined' ? time : 20;

    isStorybook && setShowModal(true);
    window.addEventListener('keydown', handleEsc);
    window.addEventListener('mousedown', handleOutsideClick);
    window.addEventListener('load', setIdleTimeout(expireSeconds, idleTimeout));
    document.addEventListener('mouseleave', displayModal);

    // Clean up event listeners after popup is closed
    return () => {
      window.removeEventListener('keydown', handleEsc);
      window.removeEventListener('mousedown', handleOutsideClick);
      window.removeEventListener('load', setIdleTimeout);
      document.removeEventListener('mouseleave', displayModal);
    };
  }, []);

  return (
    <div
      className={`${styles.popup} ${toggle ? styles.toggleButton : styles.defaultPopup} ${
        style && styles[style]
      }`}
    >
      <div
        onClick={() => handelActive(false)}
        className={`${styles.modalOverlay} ${!showModal ? styles.hideOverlay : ''}`}
      />
      <div className={`${styles.modalInner} ${showModal ? styles.activeModal : ''} `} ref={modal}>
        <div className={styles.itemsContent}>
          <div className={styles.popupCenter}>
            <div className={styles.modalContent}>
              <div className={styles.modalTitle}>
                <p>{title}</p>
                <button
                  className={`${styles.closeIcon} popup-gtm btn-cta`}
                  onClick={() => handelActive(false)}
                >
                  <MdClose title="Close Icon" />
                </button>
              </div>
              {shownItems?.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <PopupCard key={index} item={item} tracker={tracker} template={template} />
              ))}
            </div>
            {toggle && !link && (
              <div
                className={styles.toggleButtonPopup}
                onClick={() => {
                  handelActive(!showModal);
                }}
              >
                {icon}
                <p>{toggleTitle}</p>
              </div>
            )}
            {toggle && link && (
              <Link className={styles.toggleButtonPopup} to={link}>
                {icon}
                <p>{toggleTitle}</p>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
